import React, {  } from "react";
import "./index.css";
import SideBar from "../Sidebar";
import { Outlet } from "react-router-dom"; // Removed unused imports
import Header from "../header";
import Breadcrumbs from "../breadcrumb/breadcrumbs";

function Transactions() {

  return (
    <div className="">
      <Header />
      <div className="row rowdesign">
        <div className="col-3">
          <SideBar />
        </div>
        <div className="col-9 bodyPart">
          <Breadcrumbs />
          <div >
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Transactions;
